import InfoTooltip from 'components/InfoTooltip';
import { LabelField } from 'components/LabelField';
import React from 'react';
import { TextAreaMessage, TextMessageItem, TextMessagesList, TextMessageWrapper } from './Theme';
import { tokenList } from './tabsContants';

const TextMessage = ({onTokenDoubleClicked,onTextAreaChange, value}) => {
  return (
    <div className="group-input">
      <div className="text-arrow-icon d-flex align-items-center" style={{ justifyContent: 'flex-start' }}>
        <LabelField
          title={"Text"}
          style={{
            fontSize: "12px",
          }}
          mandatory={true}
        />
        <InfoTooltip text="Double-click a token on the right to insert it into the message text, so it's replaced with the actual value (e.g. member name) when the task is created." placement="bottom" useFixed style={{ marginLeft: '6px', marginBottom: '4px', transform: 'translateY(-3px)' }} />
      </div>
      <TextMessageWrapper>
        <TextAreaMessage
          aria-label="empty textarea"
          minRows={12}
          placeholder="Add your text here"
          value={value}
          onChange={onTextAreaChange}
        />
        <TextMessagesList>
          {tokenList.map((token) => (
            <TextMessageItem onDoubleClick={() => onTokenDoubleClicked(token)}>
              {token}
            </TextMessageItem>
          ))}
        </TextMessagesList>
      </TextMessageWrapper>
    </div>
  )
}

export default TextMessage